import _ from "lodash";
import { colors, getCloudUrl } from "Constants";

const STATUS_NOT_STARTED = "NOT_STARTED";
const STATUS_PLAN_CHANGE_NOT_STARTED = "PLAN_CHANGE_NOT_STARTED";
const STATUS_IN_PROGRESS = "IN_PROGRESS";
const STATUS_QC_INITIATED = "QC_INITIATED";
const STATUS_SETUP_COMPLETE = "COMPLETE";
const GRADES = "GRADES";
const YEAR_GROUPS = "YEAR_GROUPS";

const curriculumCardDetails = t => {
  return {
    IB_PYP: {
      color: colors.salmon60,
      title: t("common:pyp"),
      imageURL: `${getCloudUrl()}/assets/webapp/SchoolOnboardingPYPSetupV2.svg`,
      label: t("common:PYP"),
    },
    IB_MYP: {
      color: colors.violet500,
      title: t("common:myp"),
      imageURL: `${getCloudUrl()}/assets/webapp/SchoolOnboardingMYPSetupV2.svg`,
      label: t("common:MYP"),
    },
    UBD: {
      color: colors.yellow500,
      title: t("common:ubd"),
      imageURL: `${getCloudUrl()}/assets/webapp/SchoolOnboardingUBDSetup.svg`,
      label: t("common:UBD"),
    },
    IB_DP: {
      color: colors.salmon60,
      title: t("common:dp"),
      imageURL: `${getCloudUrl()}/assets/webapp/SchoolOnboardingPYPSetupV2.svg`,
      label: t("common:DP"),
    },
  };
};

const getStepLabel = ({ selectedStep, t }) => {
  const count = _.last(_.split(selectedStep, "_"));
  return t("onBoarding:step_count", { count });
};

export {
  STATUS_NOT_STARTED,
  STATUS_PLAN_CHANGE_NOT_STARTED,
  STATUS_IN_PROGRESS,
  STATUS_QC_INITIATED,
  STATUS_SETUP_COMPLETE,
  GRADES,
  YEAR_GROUPS,
  curriculumCardDetails,
  getStepLabel,
};
